// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MwwQb","col":"styles_col__17cqM","actions":"styles_actions__ejyQo","conflict":"styles_conflict__3oP8D"};